import type { SelectedOption } from "@shopify/hydrogen-react/storefront-api-types";
import React from "react";

interface IProps {
  title: string[];
  data: string[][];
  options: SelectedOption[][];
}

function SizeTable({ options, title, data }: IProps) {
  return (
    <table className="w-full table-fixed">
      <thead>
        <tr className="h-8">
          <td className="pl-3">Size</td>
          {title.map((name, index) => (
            <td key={index}>{name}</td>
          ))}
        </tr>
      </thead>
      <tbody>
        {options.map((option, rowIndex) => (
          <tr className="h-7 odd:bg-tertiary" key={rowIndex}>
            <td className="rounded-l-lg pl-3">{option[1].value}</td>
            {data.map((size, columnIndex) => (
              <td className="last:rounded-r-lg" key={columnIndex}>
                {size[rowIndex]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default SizeTable;
